import React from 'react';
import styled from 'styled-components';
import {InnerLayout} from '../styles/Layouts';

import SmallTitle from '../Components/SmallTitle';
import BusinessCenterIcon from '@material-ui/icons/BusinessCenter';
import SchoolIcon from '@material-ui/icons/School';
import ResumeItem from '../Components/ResumeItem';

function Resume() {
    const briefcase = <BusinessCenterIcon />
    const school = <SchoolIcon />
    return (
        <ResumeStyled>
            
            <InnerLayout>
                <div className="small-title">
                    <SmallTitle icon={briefcase} title={'Certifications & Working Experience'} />
                </div>
                <div className="resume-content">
         <ResumeItem 
                        year={'June 2024 - Present'} 
                        title={'Software Developer,'}
                        subTitle={'Aadrika Enterprises, Ranchi'}
                        text={' Led the end-to-end design and development of the Symtomcare Hospital Information Management System (HIMS), using Next.js, PostgreSQL, Laravel, and Redux to optimize patient management and streamline hospital operations '} 
                    />
                            
                    <ResumeItem 
                        year={'May 2024 - Apr 2024'} 
                        title={'Full Stack Developer'}
                        subTitle={'Macreel Infosoft, Noida'}
                        text={'Developed and optimized a web application , improving functionality and user experience. '} 
                    />
                    <ResumeItem 
                        year={'Oct 2022 - Mar 2023'} 
                        title={'Frontend Developer, Remote'}
                        subTitle={'Zluck Solutions, Gujarat'}
                       
                       text={'Designed and developed dynamic enterprise applications using ReactJs, NextJs, Redux, and more, contributing and delivering over  20+ Projects'} 
                    />
                    <ResumeItem 
                        year={'Aug 2021 -Dec 2021'} 
                        title={'Frontend Developer'}
                        subTitle={'SamaGram PVT. LTD. Bhopal'}
               
                        text={'Developed and optimized a web application , improving functionality and user experience. '} 
                    />
                    
                 
                </div>
                <div className="small-title u-small-title-margin">
                    <SmallTitle icon={school} title={'Educational Qualifications'} />
                </div>
                <div className="resume-content ">
                    <ResumeItem 
                        year={'2017 - 2022'} 
                        title={'Computer Science (B.Tech)'}
                        subTitle={'RGPV, Bhopal'}
                        text={'I have done graduate from Bansal College of Engineering, Mandideep. Approved by AICTE, Affiliated to RGPV, Bhopal '} 
                    />
                    <ResumeItem 
                        year={'2015 - 2017'} 
                        title={'Intermediate'}
                        subTitle={'Inter Science College, Hazaribagh'}
                        text={' I have done intermediate from Inter Science College, Hazaribagh. Based on Jharkhand Academic Council(State Board). '} 
                    />
                    <ResumeItem 
                        year={'2013 - 2015'} 
                        title={'High School'}
                        subTitle={'High School Barhi'}
                        text={' I have done High School from High School, Barhi. Based on Jharkhand Academic Council(State Board). '} 
                    />
                </div>
            </InnerLayout>
        </ResumeStyled>    
    )
}

const ResumeStyled = styled.section`
    .small-title{
        padding-bottom: 3rem;
    }
    .u-small-title-margin{
        margin-top: 4rem;
    }

    .resume-content{
        border-left: 1px solid var(--border-color);
    }
`;
export default Resume
